'use client'

import React, { useEffect, useState } from "react";
import { motion } from 'framer-motion';
import { Typography, Box } from '@mui/material';
import { Card } from "@heroui/react";
import Link from 'next/link';
import Image from 'next/image';

export const ProjectSection = ({ data, imageUrls }) => {
    const [columnCount, setColumnCount] = useState(3);
    const masonryStyle = {
        columnCount: columnCount,
        columnGap: "1rem",
    };

    const boxStyle = {
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        height: 'auto',
    };

    useEffect(() => {
        const updateColumnCount = () => {
            if (window.innerWidth < 600) {
                setColumnCount(1);
            } else if (window.innerWidth >= 600 && window.innerWidth < 900) {
                setColumnCount(2);
            } else if (window.innerWidth >= 900 && window.innerWidth < 1200) {
                setColumnCount(4);
            } else {
                setColumnCount(5);
            }
        };

        window.addEventListener('resize', updateColumnCount);
        updateColumnCount(); // Initial check on component mount

        return () => window.removeEventListener('resize', updateColumnCount);
    }, []);



    return (
        <motion.section
            className="section-large project-section"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom>
                        Projekte
                    </Typography>
                </div>
            </div>
            <div className="section-body">
                <div style={masonryStyle}>
                    {data && imageUrls && data.map((item, index) => {
                        const bild = imageUrls[item.projekt_id];
                        const imageSrc = bild?.url ?? '/images/default.webp';
                        const imageWidth = bild?.width || 500;
                        const imageHeight = bild?.height || 300;
                        return (
                            <Link key={index} href={`/projekte/${encodeURIComponent(item.projekt_id)}`} style={{ textDecoration: 'none', marginBottom: '1rem', display: 'block' }}>
                                <Card>
                                    <Box sx={boxStyle}>
                                        <Image
                                            alt={item.titel}
                                            src={imageSrc}
                                            width={500}
                                            height={Math.round((imageHeight / imageWidth) * 500)} // Maintain aspect ratio
                                            style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                                            loading="lazy"
                                        />
                                        <div className="project-name-overlay">
                                            <Typography variant="caption" className="external-link">
                                                {item.jahr}
                                            </Typography>
                                            <Box style={{ height: '100%', width: 'auto', display: 'flex', alignSelf: 'center' }}>
                                                <Typography variant="body2" gutterBottom className="external-link overlay-text">
                                                    {item.titel}
                                                </Typography>
                                            </Box>
                                        </div>
                                    </Box>
                                </Card>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </motion.section>
    );
};
